/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsectionhours3Inputs */

const en_placewebsectionhours3 = /** @type {(inputs: Placewebsectionhours3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening hours`)
};

const de_placewebsectionhours3 = /** @type {(inputs: Placewebsectionhours3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnungszeiten`)
};

/**
* | output |
* | --- |
* | "Opening hours" |
*
* @param {Placewebsectionhours3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsectionhours3 = /** @type {((inputs?: Placewebsectionhours3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsectionhours3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsectionhours3(inputs)
	return de_placewebsectionhours3(inputs)
});
export { placewebsectionhours3 as "placeWebSectionHours" }